<section class="container">
  <div class="page-header-container">
    <div class="page-title-container">
      <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 class="page-title" translate>Page List</h1>
    </div>
  </div>

  <table
    mat-table
    [dataSource]="JobApplicantsList"
    *ngIf="JobApplicantsList"
    class="mat-elevation-z8 full-width-table"
  >
    <!-- Applicant Name Column -->
    <ng-container matColumnDef="Applican_Name">
      <th mat-header-cell *matHeaderCellDef translate>Applicant Name</th>
      <td mat-cell *matCellDef="let element">
        {{ element.first_name }} {{ element.last_name }}
      </td>
    </ng-container>

    <!-- Mobile Number Column -->
    <ng-container matColumnDef="Mobile_Number">
      <th mat-header-cell *matHeaderCellDef translate>Mobile Number</th>
      <td mat-cell *matCellDef="let element">{{ element.mobile_number }}</td>
    </ng-container>

    <!-- Email Column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef translate>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    <ng-container matColumnDef="resume">
      <th mat-header-cell *matHeaderCellDef translate>Resume</th>
      <td mat-cell *matCellDef="let element">
        <a
          *ngIf="element.cv_url"
          [href]="getResumeUrl(element.cv_url)"
          target="_blank"
          matTooltip="View Resume"
        >
          <i class="fa-solid fa-download"></i> <span translate>Download</span>
        </a>
        <span *ngIf="!element.cv_url" class="no-resume" translate>No Data Found</span>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef translate>Status</th>
      <td mat-cell *matCellDef="let element">
        <span
          class="status-badge"
          [ngClass]="{
            selected: element.status === 'SELECTED',
            rejected: element.status === 'REJECTED',
            pending: element.status === 'PENDING'
          }"
        >
          {{ element.status }}
        </span>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef translate>Actions</th>
      <td mat-cell *matCellDef="let element">
        <i class="fa-solid fa-ellipsis-vertical"></i>
      </td>
    </ng-container>

    <!-- Header & Row Rendering -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="applicant-row"
    ></tr>
  </table>
  <div *ngIf="JobApplicantsList.length === 0" class="no-data" translate>
    No applicants found.
  </div>
</section>
